import { render } from "./StaffAddTask.vue?vue&type=template&id=51cbf865"
import script from "./StaffAddTask.vue?vue&type=script&lang=js"
export * from "./StaffAddTask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__